import api from './api';
import styles from './styles';
import messages from './messages';

export default {
  api,
  messages,
  styles
};
